import React from "react";
import { FormattedNumber } from "react-intl";
import { FaInfoCircle,FaEuroSign } from "react-icons/fa";

import { currencySymbol } from "../utils.js";
import { setOfferFlexbooked } from "amadeusredux/lib/hotelSlice.js";
import { useDispatch } from "react-redux";
import InfoPopupHover from "../components/InfoPopupHover";

import { FaLongArrowAltUp } from "react-icons/fa";
import { FaLongArrowAltDown } from "react-icons/fa";
import PriceChange from "../components/PriceChange.js";

export default function TourOperatorsBoard(props) {
  let {
    allBoards,
    tourOperators,
    travellerfactor,
    currencyCode,
    offsetTop,
    roomTouroperators,
    setFlexSelected,
  } = props;
  const dispatch = useDispatch();
  if (!Array.isArray(allBoards)) allBoards = [];
  if (!Array.isArray(tourOperators)) tourOperators = [];

  let cheapestprice = 99999999999;

  for (let i = 0; i < tourOperators.length; i++) {
    for (let j = 0; j < allBoards.length; j++) {
      let bt = allBoards[j];
      let cheapest = tourOperators[i].offers.find(
        (e) => e.boardtype === bt.value
      );

      if (cheapest) {
        if (
          cheapestprice > cheapest.price * travellerfactor &&
          cheapest.checked !== -1
        ) {
          cheapestprice = cheapest.price * travellerfactor;
        }
      }
    }
  }
  for (let i = 0; i < tourOperators.length; i++) {
    for (let j = 0; j < allBoards.length; j++) {
      let bt = allBoards[j];
      let cheapest = tourOperators[i].offers.find(
        (e) => e.boardtype === bt.value
      );

      if (cheapest) {
        if (
          cheapestprice === cheapest.price * travellerfactor &&
          cheapest.checked !== -1
        ) {
          tourOperators[i].isCheapest = true;
        }
      }
    }
  }

  return (
    <>
      {/*<div style={{ fontSize: "1.5em", fontWeight: 600 }}>Veranstalter</div>*/}
      <div
        style={{
          display: "flex",
        }}
      >
        <div
          style={{
            minWidth: 100 / (allBoards.length + 1) - 1 + "%",
            width: 100 / (allBoards.length + 1) - 1 + "%",
            maxWidth: 100 / (allBoards.length + 1) - 1 + "%",
            padding: 2,
            overflow: "hidden",
            marginRight: "1%",
            whiteSpace: "nowrap",
            fontSize: "1.2em",
            fontWeight: 600,
          }}
        >
          Veranstalter<br/>(Preise für Standardangebote)
        </div>
        {allBoards.map((bt) => {
          return (
            <div
              style={{
                padding: 2,
                marginRight: "1%",
                minWidth: 100 / (allBoards.length + 1) - 1 + "%",
                width: 100 / (allBoards.length + 1) - 1 + "%",
                maxWidth: 100 / (allBoards.length + 1) - 1 + "%",
                fontSize: "1.2em",
                overflow: "hidden",
                fontWeight: 600,
              }}
            >
              {bt.label}
            </div>
          );
        })}
      </div>

      {tourOperators.map((to, idx) => {
        //console.log(to)
        return (
          <div
            className="board"
            style={{
              backgroundColor: idx % 2 ? "white" : "#f3f0ed",
            }}
          >
            <div
              className="board1"
              style={{
                minWidth: 100 / (allBoards.length + 1) - 1 + "%",
                width: 100 / (allBoards.length + 1) - 1 + "%",
                maxWidth: 100 / (allBoards.length + 1) - 1 + "%",
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontWeight: roomTouroperators.tos.includes(to.code) ? 700 : 400,
              }}
            >
              <span className={to.isCheapest ? "colorpositive" : ""}>
                {to.label}
              </span>
              <InfoPopupHover
                trigger={
                  <span className="infoicon">
                    &nbsp;
                    <span className="colorpositive" title={to.touroperatoraction}>
                      {to.touroperatoraction && <FaEuroSign />}
                    </span>{" "}

                  </span>
                }
                content={
                  "" +
                  (to.marketingproperties ? to.marketingproperties.mouseover : "")
                }
                position={"right center"}
              ></InfoPopupHover>              
              &nbsp;&nbsp;&nbsp;
              <InfoPopupHover
                trigger={
                  <span className="infoicon">
                    {(to.flexoption || to.reservation) && <FaInfoCircle />}
                  </span>
                }
                content={
                  "" +
                  (to.reservationtext && to.reservation ? to.reservationtext : "") +
                  (to.reservation && to.flexoption ? "<br/>" : "") +
                  (to.flexoptiontext && to.flexoption ? to.flexoptiontext : "")
                }
                position={"right center"}
              ></InfoPopupHover>

          
            
            </div>
            {allBoards.map((bt, i) => {
              let cheapest = to.offers.find((e) => e.boardtype === bt.value);
              return (
                <div
                  className={i === allBoards.length - 1 ? "board2" : "board1"}
                  style={{
                    minWidth: 100 / (allBoards.length + 1) - 1 + "%",
                    display: "flex",
                  }}
                >
                  {" "}
                  {cheapest && !isNaN(cheapest.price * travellerfactor) && (
                    <span>ab&nbsp;</span>
                  )}
                  {cheapest ? (
                    <span
                      className={
                        "price" +
                        (cheapest.price * travellerfactor === cheapestprice &&
                          cheapest.checked !== -1
                          ? " colorpositive"
                          : "")
                      }
                      style={{
                        fontWeight:
                          (cheapest.price * travellerfactor === cheapestprice &&
                            cheapest.checked !== -1) ||
                            to.isCheapest
                            ? 700
                            : undefined,
                        textDecoration:
                          cheapest.checked == -1 ? "line-through" : undefined,
                      }}
                      onClick={() => {
                        setFlexSelected(false);
                        dispatch(
                          setOfferFlexbooked({
                            offerId: cheapest.offerid,
                            flexbooked: false,
                          })
                        );
                        window.scrollTo(0, offsetTop);
                        props.setOfferId(cheapest.offerid);
                        props.setOperator(cheapest.value);
                      }}
                    >
                      <PriceChange
                        price={cheapest.price}
                        checked={cheapest.checked}
                        cacheprice={cheapest.cacheprice}
                        travellerfactor={travellerfactor}
                        currencyCode={currencyCode}
                      />
                      {!isNaN(cheapest.price * travellerfactor) && (
                        <>
                          <FormattedNumber
                            value={cheapest.price * travellerfactor}
                            minimumFractionDigits={0}
                            maximumFractionDigits={0}
                          />
                          &nbsp;
                        </>
                      )}
                      {currencySymbol(currencyCode)}
                    </span>
                  ) : (
                    <span></span>
                  )}
                  {cheapest && !isNaN(cheapest.price * travellerfactor) && (
                    <>
                      {/*
                      &nbsp;&nbsp;&nbsp;(
                      {to.offers.filter((e) => e.boardtype === bt.value).length}
                      )
                      */}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}
